import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import * as Module from '../../modules';
import { ERROR_COLOR } from "../../const";
import { stateProps } from "../../modules/state";
import { useDispatch } from "react-redux";

const ToastBox = styled.span`
    position: fixed;
    bottom: -52px;
    height: 52px;
    width: 17rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${ERROR_COLOR[500]};
    color: white;
    border-radius: 1.4rem;

    transition: 0.6s ease-in-out;

    &.open {
        transform: translateY(-62px);
    }
    &.close {
        transform: translateY(54px);
    }

    & p {
        margin: 0;
        padding: 2px;

        &.error-title {
            font-weight: 600;
            font-size: 1rem;
        }
        &.error-message {
            font-size: 0.78rem;
        }
    }
`;

const Toast = () => {
    const { title, message } = useSelector((state: stateProps) => ({
        title: state.toast.title,
        message: state.toast.message,
    }));
    const [state, setState] = useState('');
    const APPEARTIME = 2000;
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => {
            setState('open');
        }, 100);
        setTimeout(() => {
            setState('close');
        }, APPEARTIME);
        setTimeout(() => {
            dispatch(Module.closeToast());
        }, APPEARTIME + 1000);
    }, [dispatch]);

    return (
        <ToastBox className={`${state !== '' ? state === 'open' ? 'open' : 'close' : ''}`}>
            <p className="error-title">{title}</p>
            <p className="error-message">{message}</p>
        </ToastBox>
    );
};

export default Toast;